import { useCallback } from 'react';
import { UseFormWatch } from 'react-hook-form';

import { DeliveryMethod } from 'apps/shared/scripts/__generated__/graphql.generated';
import { Button, ButtonTypes } from 'apps/shared/scripts/components';

import { FORM_FIELDS } from '../constants';
import { FormValues } from '../types';

import { cardDeliveryFooterClassName } from './styles';

interface Props {
  isDisabled?: boolean;
  isSubmitting?: boolean;
  onSubmit: () => void;
  watch: UseFormWatch<FormValues>;
}

const CardDeliveryFooter = ({
  isDisabled,
  isSubmitting,
  onSubmit,
  watch,
}: Props) => {
  const preference = watch(FORM_FIELDS.DELIVERY_METHOD.name);
  const isManual = preference === DeliveryMethod.Manual;

  const onClick = useCallback(async () => {
    if (
      window.confirm(
        `Are you sure you want to ${isManual ? 'publish' : 'send'} this card?`,
      )
    ) {
      onSubmit();
    }
  }, [isManual, onSubmit]);

  return (
    <div className={cardDeliveryFooterClassName}>
      <Button
        disabled={isDisabled || isSubmitting}
        loading={isSubmitting}
        onClick={onClick}
        type={ButtonTypes.Button}
        primary
        fullWidth
      >
        {isManual ? 'Publish' : 'Send'}
      </Button>
    </div>
  );
};

CardDeliveryFooter.displayName = 'CardDeliveryFooter';

export default CardDeliveryFooter;
